import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  didCommentFailSubmittingToServerSelectorMaker,
  didCommentsFetchingFailSelector,
  getCommentsQueryStateSelector,
  isCommentSubmittingToServerSelectorMaker
} from './selectors'
import { CommentId } from './types'
import { commentsApi, getFixedCacheKey } from './api'
import { useBotId } from '../../store/flow'

export const useCommentQueryState = () => {
  return useSelector(getCommentsQueryStateSelector)
}

export const useAreCommentsLoading = (): boolean => {
  return useCommentQueryState().isLoading
}
export const useDidCommentsFailToFetch = () => {
  return useSelector(didCommentsFetchingFailSelector)
}
export const useIsCommentSubmitting = (commentId: CommentId) => {
  return useSelector(isCommentSubmittingToServerSelectorMaker(commentId))
}
export const useDidCommentFailToSubmit = (commentId: CommentId) => {
  return useSelector(didCommentFailSubmittingToServerSelectorMaker(commentId))
}

export const useFetchCommentsFromServerToRedux = () => {
  const dispatch = useDispatch()
  const botId = useBotId()

  useEffect(() => {
    if (botId) {
      dispatch(commentsApi.endpoints.getComments.initiate({ botId }))
    }
  }, [botId, dispatch])
}

export const useResetMutationsForComment = (commentId: CommentId) => {
  // I would love to do this inside a thunk, but I can't find a way to
  // access those methods outside of hook context :/
  // https://stackoverflow.com/q/72789932/10467064
  const [, updateApi] = commentsApi.useUpdateCommentMutation({
    fixedCacheKey: getFixedCacheKey.updateComment(commentId)
  })

  const [, submitApi] = commentsApi.useSubmitNewCommentMutation({
    fixedCacheKey: getFixedCacheKey.submitNewComment(commentId)
  })

  return () => {
    updateApi.reset()
    submitApi.reset()
  }
}
